import styled from "styled-components";

const CocktailRate = styled.p`
  display: inline-block;
  width: 50%;
  margin-top: 5px;
  margin-bottom: 15px;
  margin-left: 5%;
  color: #00b9cd;
`;

export default CocktailRate;
